var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6131 19.6297C24.5685 15.0695 28.2664 12.8824 28.4317 12.7719C26.3535 9.67883 23.1157 9.25442 21.9633 9.20613C19.21 8.92149 16.5883 10.8569 15.1915 10.8569C13.7976 10.8569 11.6396 9.24784 9.35643 9.28882C6.35298 9.33418 3.58459 11.0669 2.03902 13.8036C-1.08017 19.3114 1.24107 27.4738 4.28046 31.944C5.76637 34.129 7.5384 36.5876 9.86323 36.4976C12.104 36.4076 12.9494 35.0224 15.6581 35.0224C18.3668 35.0224 19.1273 36.4976 21.4975 36.4515C23.9071 36.4068 25.4347 34.2248 26.9084 32.0311C28.6143 29.4927 29.3167 27.0348 29.3583 26.9104C29.3059 26.8855 24.6612 25.0745 24.6131 19.6297Z",
    fill: "#919699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1596 6.24776C21.3925 4.72429 22.2278 2.60739 22.0006 0.5C20.2214 0.573173 18.0677 1.7037 16.7902 3.2257C15.6458 4.57648 14.6451 6.72705 14.9133 8.79639C16.8981 8.95298 18.9224 7.7683 20.1596 6.24776Z",
    fill: "#919699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon-apple.c7170f310a9fab49d135acaad14a263a.svg";
export { ForwardRef as ReactComponent };